import { makeAutoObservable } from 'mobx'
import { type INormalizedApiError } from 'shared/api'
import { AgentActions, type IAgentActionSettings } from 'entities/AgentActions'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { AgentActionsControl } from 'widgets/AgentActions'
import { SuccessActionsErrors } from './successActionsErrors'

export class CategoryActionsStore {
  private readonly _model = new AgentActions()
  private readonly _errors: SuccessActionsErrors
  private readonly _control: AgentActionsControl

  constructor(entities: IEntitiesStore, rootKey: string) {
    this._errors = new SuccessActionsErrors(rootKey)
    this._control = new AgentActionsControl(this._model, entities)
    makeAutoObservable(this)
  }

  get control() {
    return this._control
  }

  get errors() {
    return this._errors
  }

  get sectionError() {
    return this._errors.sectionError
  }

  get hasActions() {
    return this._control.list.length > 0
  }

  init = (value: IAgentActionSettings[] | null | undefined) => {
    this._model.syncOrigin(value ?? [])
    this._errors.clear()
  }

  syncApiErrors = (apiErrors: INormalizedApiError | null | undefined) => {
    this._errors.sync(apiErrors, this._model)
  }

  resetSectionError = () => {
    if (this._errors.hasOwnSectionError) this._errors.removeSectionError()
  }

  dispose = () => {
    this._control.dispose()
  }

  get paramsValue(): IAgentActionSettings[] | null {
    const list = this._model.toJSON()
    return list.length > 0 ? list : null
  }
}
